/**
 * 利用申込書(A/B)
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/tenants/jwnet_join_application_forms`

const jwnet_join_application_form = {
namespaced: true,
actions: {
  show ({ commit }, { params }) {
    return new Promise((resolve) => {
      Vue.$http.get(API_PATH, { params: params }).then(data => {
        resolve(data.content)
      })
    })
  },
},
}
export default jwnet_join_application_form
